var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16MenuTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.29 6H.99C.444 6 0 6.444 0 6.99v5.798c0 .547.444.99.99.99h12.3c.546 0 .99-.443.99-.99V6.99c0-.547-.444-.991-.99-.991z",
    transform: "translate(-556 -49) translate(556 49) translate(.9 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M13.6 4.642L12.113.557c-.16-.44-.645-.666-1.084-.506L1.157 3.644c-.322.117-.53.409-.554.729-.01.117.005.238.048.356",
    transform: "translate(-556 -49) translate(556 49) translate(.9 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M3.949 9L3.949 13",
    transform: "translate(-556 -49) translate(556 49) translate(.9 1) rotate(-90 3.95 11)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M2.949 8L2.949 10",
    transform: "translate(-556 -49) translate(556 49) translate(.9 1) rotate(-90 2.95 9)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16MenuTicket);
export default __webpack_public_path__ + "static/media/ico16MenuTicket.e1728c20.svg";
export { ForwardRef as ReactComponent };